import { OPEN_NOTIFICATION, HIDE_NOTIFICATION } from 'constants/notification';

export default function notification(
  state = {
    open: false,
    text: '',
    type: null,
    timer: null,
  },
  action,
) {
  switch (action.type) {
    case OPEN_NOTIFICATION:
      return {
        ...state,
        open: true,
        text: action.message.text,
        type: action.message.type,
        timer: action.message.timer,
      };
    case HIDE_NOTIFICATION:
      return {
        ...state,
        open: false,
        text: '',
        type: null,
        timer: null,
      };
    default:
      return state;
  }
}
